<template>
  <div :class="{ '-is-scrolled-top': $store.state.isScrolledTop }">
    <ion-app>
      <!-- <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 757.3 325"
      class="c-wave-big -violet"
      xml:space="preserve"
    >
      <g class="slider_wave_2">
        <path
          d="M5.7,347.3h751.5v-16.8c0,0-125.8-100.2-212.7-36.4C308.1,371.4,314.1-58.3,135.3,88.7C27,170,5.7,347.3,5.7,347.3z"
        />
      </g>
      <g class="slider_wave_1">
        <path
          d="M0,347.3h757.3v-17.1c0,0-214.5-66.6-392.2-42.1C211.9,321.7,258.7,51,139.9,39.1 C17.8,52.1,0,347.3,0,347.3z"
        />
      </g>
    </svg> -->
      <svg
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        viewBox="0 0 2586.8 178.2"
        style="enable-background: new 0 0 2586.8 178.2; display: none"
        xml:space="preserve"
        class="c-waves">
        <g id="wave_3">
          <path
            id="Pfad_8"
            class="st0"
            d="M1692.4,44.2c-385.6,133.4-389.6-98.6-705.9,11C702.2,153.8,541.8-80.3,360.3,97.9
		c-0.5,68.7,0.5,79.7,0.5,79.7h1628l0.4-79.7C1989.1,97.9,1854.4-22,1692.4,44.2z" />
        </g>
        <g id="wave_2">
          <path
            id="Pfad_9_2_"
            class="st1"
            d="M1848.6,29.5c-370.8,167.2-501.1-141.1-917.7,17.3c-465.1,176.8-497.1-221.2-814,66.9
		c0,32.9-0.1,63.9-0.1,63.9h2110l-0.2-63.9C2226.6,113.7,2062.7-67.1,1848.6,29.5z" />
        </g>
        <g id="wave_1">
          <path
            id="Pfad_10_1_"
            class="st2"
            d="M1082.8,100.7c-544,192-828-220-1082.8,76.4c248.4,2.5,2586.8,0,2586.8,0
		s-200.1-216.3-614-105.4C1550.8,184.7,1530.4-57.3,1082.8,100.7z" />
        </g>
      </svg>
      <ion-menu
        side="end"
        type="overlay"
        content-id="main"
        :swipeGesture="false"
        class="c-menu">
        <ion-header class="ion-no-border">
          <!-- <img
          class="ion-padding"
          width="200"
          src="@/assets/img/roodie_logo_violet.svg"
          alt="Roodie Logo"
        /> -->
          <div class="c-menu__header">
            <img
              width="120"
              src="@/assets/img/roodie_logo_white.svg"
              alt="Roodie Logo" />
          </div>
        </ion-header>
        <ion-content class="ion-padding">
          <ion-list>
            <ion-item button @click="goHome">
              <ion-label>Home</ion-label>
              <ion-icon
                color="primary"
                :icon="homeOutline"
                slot="end"></ion-icon>
            </ion-item>
            <ion-item
              button
              router-link="/profil"
              @click="$store.commit('setCloseMenu', true)">
              <ion-label>Profil</ion-label>
              <ion-icon
                color="primary"
                :icon="personOutline"
                slot="end"></ion-icon>
            </ion-item>
            <ion-item
              button
              router-link="/roodie-safe"
              @click="$store.commit('setCloseMenu', true)">
              <ion-label>Roodie.Safe</ion-label>
              <ion-icon
                color="primary"
                :icon="keyOutline"
                slot="end"></ion-icon>
            </ion-item>
            <ion-item
              button
              @click="
                window.open(
                  'https://www.roodie-health.com/arag/#FAQ',
                  '_blank'
                );
                $store.commit('setCloseMenu', true);
              ">
              <ion-label>FAQ</ion-label>
              <ion-icon
                color="primary"
                :icon="helpCircleOutline"
                slot="end"></ion-icon>
            </ion-item>
            <ion-item
              button
              router-link="/kontakt"
              @click="$store.commit('setCloseMenu', true)">
              <ion-label>Kontakt</ion-label>
              <ion-icon
                color="primary"
                :icon="mailOutline"
                slot="end"></ion-icon>
            </ion-item>
            <ion-item
              button
              router-link="/einstellungen"
              @click="$store.commit('setCloseMenu', true)">
              <ion-label>Einstellungen</ion-label>
              <ion-icon
                color="primary"
                :icon="settingsOutline"
                slot="end"></ion-icon>
            </ion-item>
            <ion-item
              button
              router-link="/video"
              @click="$store.commit('setCloseMenu', true)">
              <ion-label>Video zu Roodie</ion-label>
              <ion-icon
                color="primary"
                :icon="videocamOutline"
                slot="end"></ion-icon>
            </ion-item>
            <ion-item
              button
              router-link="/information"
              @click="$store.commit('setCloseMenu', true)">
              <ion-label>Information</ion-label>
              <ion-icon
                color="primary"
                :icon="informationCircleOutline"
                slot="end"></ion-icon>
            </ion-item>
          </ion-list>
        </ion-content>
        <ion-footer class="ion-no-border">
          <ion-toolbar>
            <ion-button button @click="logout()" expand="full">
              Abmelden
              <ion-icon :icon="logOutOutline" slot="end"></ion-icon>
            </ion-button>
          </ion-toolbar>
        </ion-footer>
      </ion-menu>
      <div
        class="c-router"
        :class="{ '-stretch': ['login', 'intro'].includes($route.name) }">
        <ion-router-outlet id="main" />
      </div>
      <ion-loading
        v-if="showLoading"
        :is-open="true"
        cssClass="my-custom-class"
        message="Bitte warten..."
        :duration="$store.state.maxLoadingDuration">
      </ion-loading>
      <ion-modal
        :is-open="showErrorMessage"
        :css-class="['c-autoheight-modal']"
        @didDismiss="$store.commit('setShowErrorMessage', false)">
        <ion-page>
          <div class="ion-padding modal-content ion-text-center">
            <modal-close />
            <roodie fillOuter="#5E58BE" :expression="'happy'" />
            <h6 v-html="$store.state.errorMessage"></h6>
            <div class="ion-margin-top">
              <ion-button @click="modalController.dismiss()">Ok</ion-button>
            </div>
          </div>
        </ion-page>
      </ion-modal>
      <ion-modal
        :is-open="$store.state.showPolicyNumber"
        :css-class="['c-autoheight-modal']"
        @didDismiss="$store.commit('setShowPolicyNumber', false)">
        <ion-page>
          <div class="ion-padding modal-content">
            <modal-close />
            <img src="@/assets/img/versicherungsnummer.jpg" />
          </div>
        </ion-page>
      </ion-modal>
      <ion-modal
        :is-open="isPlatform('desktop') && innerWidth > 600"
        :css-class="['c-autoheight-modal']">
        <ion-page>
          <div class="ion-padding modal-content ion-text-center">
            <modal-close />
            <roodie fillOuter="#5E58BE" :expression="'happy'" />
            <h6>
              Sie können Roodie hier am Desktop uneingeschränkt nutzen. Wir
              empfehlen Ihnen, die Roodie App auf Ihrem Smartphone zu
              installieren.
            </h6>
            <div class="ion-margin-top">
              <ion-button
                href="https://apps.apple.com/de/app/id1604599070"
                target="_blank"
                ><ion-icon slot="start" :icon="logoApple"></ion-icon
                >iOS</ion-button
              >
              <ion-button
                href="https://play.google.com/store/apps/details?id=com.roodie_health.arag.app"
                target="_blank"
                ><ion-icon slot="start" :icon="logoAndroid"></ion-icon
                >Android</ion-button
              >
            </div>
          </div>
        </ion-page>
      </ion-modal>
    </ion-app>
  </div>
</template>

<script>
import {
  IonApp,
  IonRouterOutlet,
  // alertController,
  IonLoading,
  IonMenu,
  IonHeader,
  IonToolbar,
  // IonTitle,
  IonContent,
  IonFooter,
  IonList,
  IonItem,
  IonIcon,
  IonLabel,
  menuController,
  IonModal,
  IonPage,
  IonButton,
  modalController,
} from "@ionic/vue";
import { defineComponent } from "vue";
// import { Store } from "vuex";
import {
  logOutOutline,
  personOutline,
  // documentTextOutline,
  helpCircleOutline,
  mailOutline,
  homeOutline,
  settingsOutline,
  logoApple,
  logoAndroid,
  videocamOutline,
  informationCircleOutline,
  // calendarOutline,
  keyOutline,
} from "ionicons/icons";
// import axios from "./plugins/axios";
import Roodie from "@lib/components/svg/Roodie";
import ModalClose from "@lib/components/ModalClose";
import { isPlatform } from "@ionic/vue";
import { App } from "@capacitor/app";
import { isNavigationFailure, NavigationFailureType } from "vue-router";
import { apiLogout } from "./api/auth";

// declare module "@vue/runtime-core" {
//   // declare your own store states
//   interface State {
//     user: object;
//     showErrorMessage: boolean;
//     errorMessage: string;
//     showLoading: boolean;
//     loadingCount: number;
//     openMenu: boolean;
//     closeMenu: boolean;
//   }

//   // provide typings for `this.$store`
//   interface ComponentCustomProperties {
//     $store: Store<State>;
//   }
// }

export default defineComponent({
  name: "App",
  components: {
    IonApp,
    IonRouterOutlet,
    IonLoading,
    IonMenu,
    IonHeader,
    IonToolbar,
    // IonTitle,
    IonContent,
    IonFooter,
    IonList,
    IonItem,
    IonIcon,
    IonLabel,
    IonModal,
    IonPage,
    IonButton,
    Roodie,
    ModalClose,
  },
  data() {
    return {
      innerWidth: window.innerWidth,
      window: window,
    };
  },
  async created() {
    App.addListener("appUrlOpen", async (event) => {
      const slug = event.url.split("/app/").pop();

      // We only push to the route if there is a slug present
      if (slug) {
        const splittedSlug = slug.split("?");
        const newPath = "/" + splittedSlug[0];
        const newRoute = { path: newPath, query: {} };
        if (splittedSlug.length >= 2) {
          const paramsString = splittedSlug[1];
          if (paramsString) {
            newRoute.query = {};
            const searchParams = new URLSearchParams(paramsString);
            for (const p of searchParams) {
              newRoute.query[p[0]] = p[1];
            }
          }
        }
        const topModal = await modalController.getTop();
        if (topModal) {
          await topModal.dismiss();
        }
        const pathBeforeRouting = this.$route.path;
        const navigationResult = await this.$router.push(newRoute);
        console.log("navigationResult", navigationResult);
        if (newPath === pathBeforeRouting) {
          window.location.reload();
        } else if (
          navigationResult &&
          !isNavigationFailure(
            navigationResult,
            NavigationFailureType.duplicated
          )
        ) {
          this.$store.commit("setRouteAfterLogin", newRoute);
        }
      }
    });

    // Web Testing
    // setTimeout(async () => {
    //   const slug = "http://localhost:8080/home?rating=4&id=5ab678ff-ba06-4536-ba07-82953432fe3b"
    //     .split("8080/")
    //     .pop();

    //   // We only push to the route if there is a slug present
    //   if (slug) {
    //     const splittedSlug = slug.split("?");
    //     const newPath = "/" + splittedSlug[0];
    //     const newRoute = { path: newPath, query: {} };
    //     if (splittedSlug.length >= 2) {
    //       const paramsString = splittedSlug[1];
    //       if (paramsString) {
    //         newRoute.query = {};
    //         const searchParams = new URLSearchParams(paramsString);
    //         for (const p of searchParams) {
    //           newRoute.query[p[0]] = p[1];
    //         }
    //       }
    //     }
    //     const topModal = await modalController.getTop();
    //     if (topModal) {
    //       await topModal.dismiss();
    //     }
    //     const pathBeforeRouting = this.$route.path;
    //     const navigationResult = await this.$router.push(newRoute);
    //     console.log("navigationResult", navigationResult);
    //     if (newPath === pathBeforeRouting) {
    //       window.location.reload();
    //     } else if (
    //       navigationResult &&
    //       !isNavigationFailure(
    //         navigationResult,
    //         NavigationFailureType.duplicated
    //       )
    //     ) {
    //       this.$store.commit("setRouteAfterLogin", newRoute);
    //     }
    //   }
    // }, 3000);
  },
  setup() {
    return {
      logOutOutline,
      modalController,
      personOutline,
      // documentTextOutline,
      helpCircleOutline,
      mailOutline,
      homeOutline,
      logoApple,
      logoAndroid,
      isPlatform,
      settingsOutline,
      videocamOutline,
      informationCircleOutline,
      // calendarOutline,
      keyOutline,
    };
  },
  watch: {
    // showErrorMessage(value) {
    //   if (value) {
    //     alertController
    //       .create({
    //         header: "Bitte beachten",
    //         message: this.$store.state.errorMessage,
    //         buttons: ["Ok"],
    //       })
    //       .then((a) => {
    //         a.onDidDismiss().then(() => {
    //           this.$store.commit("setShowErrorMessage", false);
    //         });
    //         a.present();
    //       });
    //   }
    // },
    loadingCount(newVal) {
      if (newVal === 0) {
        this.$store.commit("setShowLoading", false);
      }
    },
    openMenu(value) {
      if (value) {
        menuController.open("end");
        this.$store.commit("setOpenMenu", false);
      }
    },
    closeMenu(newVal) {
      if (newVal.value) {
        if (!newVal.keepModal) {
          modalController.getTop().then((modal) => {
            if (modal) {
              modalController.dismiss();
            }
          });
        }
        menuController.close("end");
        this.$store.commit("setCloseMenu", false);
      }
    },
    initials(value) {
      if (value && this.$gtm.enabled()) {
        window.dataLayer?.push({
          gender: value,
        });
      }
    },
    zip(value) {
      if (value && this.$gtm.enabled()) {
        window.dataLayer?.push({
          zip: value,
        });
      }
    },
    birthdate(value) {
      if (value && this.$gtm.enabled()) {
        window.dataLayer?.push({
          age: this.getAge(value),
        });
      }
    },
  },
  methods: {
    goHome() {
      if (this.$route.name === "home") {
        // this.$router.go(0);
        // window.location.reload();
        this.$store.commit("setResetHomeView", true);
        this.$store.commit("setCloseMenuKeepModal", true);
      } else {
        this.$router.push({ name: "home" });
        this.$store.commit("setCloseMenu", true);
      }
    },
    logout() {
      apiLogout();
      // this.$store.commit("setShowLoading", true);
      // axios.post("?Mode=General&Function=Logout").then((response) => {
      //   console.log(response);
      //   if (response.data.Status === "Error") {
      //     this.$store.commit("setErrors", response.data.Errors);
      //   } else {
      //     this.$store.commit("setUser", {});
      //     this.$store.commit("setRoodieChecks", {});
      //     this.$store.commit("setResetHomeViewForce", true);
      //     this.$store.commit("setCloseMenu", true);
      //     this.$router.push("/login");
      //   }
      // });
    },
    getAge(dateString) {
      const today = new Date();
      const birthDate = new Date(dateString);
      let age = today.getFullYear() - birthDate.getFullYear();
      const m = today.getMonth() - birthDate.getMonth();
      if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
        age--;
      }
      return age;
    },
  },
  computed: {
    showErrorMessage() {
      return this.$store.state.showErrorMessage;
    },
    showLoading() {
      return this.$store.state.showLoading;
    },
    loadingCount() {
      return this.$store.state.loadingCount;
    },
    openMenu() {
      return this.$store.state.openMenu;
    },
    closeMenu() {
      return this.$store.state.closeMenu;
    },
    initials() {
      return this.$store.state.user?.Initials;
    },
    zip() {
      return this.$store.state.user?.Zip;
    },
    birthdate() {
      return this.$store.state.user?.BirthDate;
    },
  },
});
</script>

<style lang="scss">
.c-menu {
  z-index: 30000;
  max-width: 1024px;
  margin: auto;
  &__header {
    position: relative;
    height: 200px;
    padding-top: 60px;
    padding-left: 10px;

    &::before {
      content: "";
      background-size: cover;
      background-repeat: no-repeat;
      // background-position: center center;
      // background-position: bottom center;
      background-image: url("./assets/img/bubble_bg_v2.svg");
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      z-index: 1;
      opacity: 0;
      animation: fade-in 2s forwards;
      background-position: bottom;

      @keyframes fade-in {
        0% {
          opacity: 0;
        }
        100% {
          opacity: 1;
        }
      }
    }

    * {
      position: relative;
      z-index: 2;
    }
  }
}

@media screen and (min-width: $breakpoint-lg) {
  ion-app {
    // background-color: white;
    background: linear-gradient(0deg, #91dccf, white);
  }

  .c-router {
    max-width: 1024px;
    margin: 0 auto;
    -webkit-box-shadow: 0 0 20px rgb(0 0 0 / 50%);
    box-shadow: 0 0 20px rgb(0 0 0 / 50%);
    // background-color: #fff;
    position: relative;
    height: 100%;
    width: 100%;

    &.-stretch {
      max-width: none;
    }
  }

  .c-waves {
    display: block !important;
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    .st0 {
      fill: #e0dbfd;
    }
    .st1 {
      fill: #d0c1f0;
    }
    .st2 {
      fill: #ffffff;
    }

    #wave_3 path {
      animation: wave_3 4s infinite;
      /*animation-delay: 2s;*/
    }
    @keyframes wave_3 {
      0% {
        d: path(
          "M1692.4,44.2c-385.6,133.4-389.6-98.6-705.9,11C702.2,153.8,541.8-80.3,360.3,97.9 c-0.5,68.7,0.5,79.7,0.5,79.7h1628l0.4-79.7C1989.1,97.9,1854.4-22,1692.4,44.2z"
        );
      }
      50% {
        d: path(
          "M1692.4,44.2c-385.6,133.4-358.6-53.6-705.9,11c-269.8,50.2-361.6-69.6-626.1,42.6		c-0.5,68.7,0.5,79.7,0.5,79.7h1628l0.4-79.7C1989.1,97.9,1873.8-14.3,1692.4,44.2z"
        );
      }
      100% {
        d: path(
          "M1692.4,44.2c-385.6,133.4-389.6-98.6-705.9,11C702.2,153.8,541.8-80.3,360.3,97.9 c-0.5,68.7,0.5,79.7,0.5,79.7h1628l0.4-79.7C1989.1,97.9,1854.4-22,1692.4,44.2z"
        );
      }
    }

    #wave_2 path {
      animation: wave_2 5s infinite;
    }
    @keyframes wave_2 {
      0% {
        d: path(
          "M1848.6,29.5c-370.8,167.2-501.1-141.1-917.7,17.3c-465.1,176.8-497.1-221.2-814,66.9 c0,32.9-0.1,63.9-0.1,63.9h2110l-0.2-63.9C2226.6,113.7,2062.7-67.1,1848.6,29.5z"
        );
      }
      50% {
        d: path(
          "M1848.6,29.5c-370.8,167.2-482.3-77.5-917.7,17.3c-481.1,104.8-475.1-136.2-814,66.9		c0,32.9-0.1,63.9-0.1,63.9h2110l-0.2-63.9C2226.6,113.7,2062.7-67.1,1848.6,29.5z"
        );
      }
      100% {
        d: path(
          "M1848.6,29.5c-370.8,167.2-501.1-141.1-917.7,17.3c-465.1,176.8-497.1-221.2-814,66.9 c0,32.9-0.1,63.9-0.1,63.9h2110l-0.2-63.9C2226.6,113.7,2062.7-67.1,1848.6,29.5z"
        );
      }
    }

    #wave_1 path {
      animation: wave_1 6s infinite;
      /*animation-delay: 4s;*/
    }
    @keyframes wave_1 {
      0% {
        d: path(
          "M1082.8,100.7c-544,192-828-220-1082.8,76.4c248.4,2.5,2586.8,0,2586.8,0		s-200.1-216.3-614-105.4C1550.8,184.7,1530.4-57.3,1082.8,100.7z"
        );
      }
      50% {
        d: path(
          "M1082.8,100.7C511.2,178.4,351.8-51.3,0,177.1c248.4,2.5,2586.8,0,2586.8,0 	s-192.5-28.2-614-105.4C1579.8-0.3,1641.8,24.7,1082.8,100.7z"
        );
      }
      100% {
        d: path(
          "M1082.8,100.7c-544,192-828-220-1082.8,76.4c248.4,2.5,2586.8,0,2586.8,0		s-200.1-216.3-614-105.4C1550.8,184.7,1530.4-57.3,1082.8,100.7z"
        );
      }
    }
  }
}

// .c-wave-big {
//   position: fixed;
//   left: 0;
//   bottom: 0;
//   width: 100%;
//   height: auto;
//   pointer-events: none;
//   // z-index: 9;
//   opacity: 1;
// }

// .slider_wave_2 path {
//   animation: wave_zwei 2s forwards;
//   animation-delay: 0.4s;
// }
// .slider_wave_1 path {
//   animation: wave_eins 2s forwards;
//   animation-delay: 0.4s;
// }

// @keyframes wave_zwei {
//   0% {
//     d: path(
//       "M5.7,347.3h751.5v-16.8c0,0-125.8-100.2-212.7-36.4C308.1,371.4,314.1-58.3,135.3,88.7C27,170,5.7,347.3,5.7,347.3z"
//     );
//   }
//   100% {
//     d: path(
//       "M51.1,347.3h706.1V2.8c0,0-103.5-14.2-190.4,49.6c-92.7,68-98.6,129-197.2,203C261.3,336.7,51.1,347.3,51.1,347.3z"
//     );
//   }
// }
// @keyframes wave_eins {
//   0% {
//     d: path(
//       "M0,347.3h757.3v-17.1c0,0-214.5-66.6-392.2-42.1C211.9,321.7,258.7,51,139.9,39.1 C17.8,52.1,0,347.3,0,347.3z"
//     );
//   }
//   100% {
//     d: path(
//       "M0,347.3h757.3V2.8c0,0-58.1-19.9-154.1,46.6c-130,90-127.5,184.1-260,245C195.7,362.2,0,347.3,0,347.3z"
//     );
//   }
// }

// .slider_wave_2 path {
//   fill: #bca7e8;
// }
// .slider_wave_1 path {
//   fill: #6ad0bf;
// }
</style>
